import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const StocksQuery = graphql(/* GraphQL */ `
  query stocks($input: StockSearchInput!) {
    stocks(input: $input) {
      ...StockOverviewPaged
    }
  }
`);
